import Vue from "vue";
export var SearchEventBus = new Vue();